import styled from '@emotion/styled';
import EmptyButton from 'ud-ui/components/empty-button';
import { theme } from 'styles/theme/theme';

export const PanelItemWrapper = styled.div`
  padding: 14px 8px;
  border-radius: 8px;
  background: ${theme.colors.SurfaceRichBlack60};
`;

export const CountButton = styled(EmptyButton)<{ size?: number }>`
  background: white;
  border: 1px solid ${theme.colors.Gray};
  border-radius: 4px;
  height: ${({ size }) => size ?? 20}px;
  width: ${({ size }) => size ?? 20}px;

  transition:
    border 0.2s ease-in-out,
    color 0.2s ease-in-out;

  &:hover {
    border: 1px solid ${theme.colors.AccentNaplesYellow};
  }
`;

export const PlayerController = styled.button`
  cursor: pointer;
  border: none;
  padding: 0;
  height: 100%;
  width: 70px;
  background: ${theme.colors.AccentNaplesYellow};
  border-radius: 8px;
  transition: background 0.2s ease-in-out;

  &:hover {
    background: ${theme.colors.NarcissusYellow};
  }

  &:active {
    transition: background 0.05s ease-in-out;
    background: ${theme.colors.AccentJonquil};
  }
`;

export const NumberWrapper = styled.div<{ backgroundColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;

  background: ${({ backgroundColor }) => backgroundColor};
  border-radius: 50%;
  width: 28px;
  height: 28px;
  overflow: hidden;
  white-space: nowrap;
`;
